"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Builder = _interopRequireDefault(require("./Builder.js"));

var _Instruction = _interopRequireWildcard(require("./Instruction.js"));

var _canvas = require("../canvas.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/render/canvas/LineStringBuilder
 */


var CanvasLineStringBuilder =
/** @class */
function (_super) {
  __extends(CanvasLineStringBuilder, _super);
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */


  function CanvasLineStringBuilder(tolerance, maxExtent, resolution, pixelRatio) {
    return _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
  }
  /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */


  CanvasLineStringBuilder.prototype.drawFlatCoordinates_ = function (flatCoordinates, offset, end, stride) {
    var myBegin = this.coordinates.length;
    var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
    var moveToLineToInstruction = [_Instruction["default"].MOVE_TO_LINE_TO, myBegin, myEnd];
    this.instructions.push(moveToLineToInstruction);
    this.hitDetectionInstructions.push(moveToLineToInstruction);
    return end;
  };
  /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */


  CanvasLineStringBuilder.prototype.drawLineString = function (lineStringGeometry, feature) {
    var state = this.state;
    var strokeStyle = state.strokeStyle;
    var lineWidth = state.lineWidth;

    if (strokeStyle === undefined || lineWidth === undefined) {
      return;
    }

    this.updateStrokeStyle(state, this.applyStroke);
    this.beginGeometry(lineStringGeometry, feature);
    this.hitDetectionInstructions.push([_Instruction["default"].SET_STROKE_STYLE, state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin, state.miterLimit, _canvas.defaultLineDash, _canvas.defaultLineDashOffset], _Instruction.beginPathInstruction);
    var flatCoordinates = lineStringGeometry.getFlatCoordinates();
    var stride = lineStringGeometry.getStride();
    this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
    this.hitDetectionInstructions.push(_Instruction.strokeInstruction);
    this.endGeometry(feature);
  };
  /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */


  CanvasLineStringBuilder.prototype.drawMultiLineString = function (multiLineStringGeometry, feature) {
    var state = this.state;
    var strokeStyle = state.strokeStyle;
    var lineWidth = state.lineWidth;

    if (strokeStyle === undefined || lineWidth === undefined) {
      return;
    }

    this.updateStrokeStyle(state, this.applyStroke);
    this.beginGeometry(multiLineStringGeometry, feature);
    this.hitDetectionInstructions.push([_Instruction["default"].SET_STROKE_STYLE, state.strokeStyle, state.lineWidth, state.lineCap, state.lineJoin, state.miterLimit, state.lineDash, state.lineDashOffset], _Instruction.beginPathInstruction);
    var ends = multiLineStringGeometry.getEnds();
    var flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
    var stride = multiLineStringGeometry.getStride();
    var offset = 0;

    for (var i = 0, ii = ends.length; i < ii; ++i) {
      offset = this.drawFlatCoordinates_(flatCoordinates, offset,
      /** @type {number} */
      ends[i], stride);
    }

    this.hitDetectionInstructions.push(_Instruction.strokeInstruction);
    this.endGeometry(feature);
  };
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */


  CanvasLineStringBuilder.prototype.finish = function () {
    var state = this.state;

    if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
      this.instructions.push(_Instruction.strokeInstruction);
    }

    this.reverseHitDetectionInstructions();
    this.state = null;
    return _super.prototype.finish.call(this);
  };
  /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */


  CanvasLineStringBuilder.prototype.applyStroke = function (state) {
    if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
      this.instructions.push(_Instruction.strokeInstruction);
      state.lastStroke = this.coordinates.length;
    }

    state.lastStroke = 0;

    _super.prototype.applyStroke.call(this, state);

    this.instructions.push(_Instruction.beginPathInstruction);
  };

  return CanvasLineStringBuilder;
}(_Builder["default"]);

var _default = CanvasLineStringBuilder;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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